import { useState, type PropsWithChildren } from 'react';
import { App as AntApp, ConfigProvider } from 'antd';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { createAppQueryClient } from '@/app/query-client';
import { marinaTheme } from '@/app/theme';

export function AppProviders({ children }: PropsWithChildren) {
  const [queryClient] = useState(createAppQueryClient);

  return (
    <ConfigProvider popupMatchSelectWidth={false} theme={marinaTheme}>
      <AntApp>
        <QueryClientProvider client={queryClient}>
          {children}
          {import.meta.env.DEV ? (
            <ReactQueryDevtools initialIsOpen={false} />
          ) : null}
        </QueryClientProvider>
      </AntApp>
    </ConfigProvider>
  );
}
